// Provider wrapper
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { Resolver, useForm } from "react-hook-form";

import {
  DEFAULT_CANVAS_CREATE_FORM_VALUES,
  DEFAULT_CANVAS_PROMPT_EDIT_FORM_VALUES,
} from "../forms/Canvas/constants";
import {
  FormTypeCanvasCreate2D,
  FormTypeCanvasPromptEdit,
} from "../forms/Canvas/types";
import {
  validationSchemaCanvasCreate2D,
  validationSchemaCanvasPromptEdit,
} from "../forms/Canvas/validationSchema";
import { useInferenceFormStore } from "./hook";
// initialize forms with default values - these forms do not change once initialized
export const InferenceFormsInitializer = () => {
  const store = useInferenceFormStore();

  const inferenceFormCanvasCreate = useForm<FormTypeCanvasCreate2D>({
    resolver: yupResolver(
      validationSchemaCanvasCreate2D,
    ) as Resolver<FormTypeCanvasCreate2D>,
    mode: "onBlur",
    defaultValues: DEFAULT_CANVAS_CREATE_FORM_VALUES,
  });

  const inferenceFormCanvasPromptEdit = useForm<FormTypeCanvasPromptEdit>({
    resolver: yupResolver(
      validationSchemaCanvasPromptEdit,
    ) as Resolver<FormTypeCanvasPromptEdit>,
    mode: "onBlur",
    defaultValues: DEFAULT_CANVAS_PROMPT_EDIT_FORM_VALUES,
  });

  useEffect(() => {
    if (!store.inferenceFormCanvasCreate2D) {
      store.setInferenceFormCanvasCreate2D(inferenceFormCanvasCreate);
    }
  }, [inferenceFormCanvasCreate, store.inferenceFormCanvasCreate2D]);

  useEffect(() => {
    if (!store.inferenceFormCanvasPromptEdit) {
      store.setInferenceFormCanvasPromptEdit(inferenceFormCanvasPromptEdit);
    }
  }, [inferenceFormCanvasPromptEdit, store.inferenceFormCanvasPromptEdit]);

  return null;
};
